import { NgModule } from '@angular/core';
import { PreventPasteDirective } from './prevent-paste';
import { PreventNonNumericDirective } from './prevent-non-numeric';
import { PreventNonNumericStrictDirective } from './prevent-non-numeric-strict';
import { PreventDecimal } from './prevent-decimal';
import { KendoGridFilterMenuMonitor } from './kendo-grid-filter-menu-monitor';
import { CursorTooltipDirective } from './cursor-tooltip';

@NgModule({
  imports: [
  ],
  declarations: [
    PreventPasteDirective,
    PreventNonNumericDirective,
    PreventNonNumericStrictDirective,
    PreventDecimal,
    KendoGridFilterMenuMonitor,
    CursorTooltipDirective,
  ],
  providers: [],
  exports: [
    PreventPasteDirective,
    PreventNonNumericDirective,
    PreventNonNumericStrictDirective,
    PreventDecimal,
    KendoGridFilterMenuMonitor,
    CursorTooltipDirective,
  ]
})
export class DirectivesModule {
}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts